document.addEventListener('DOMContentLoaded', function () {
    // const imageWrap = document.querySelector('.product-zoom-image');
    //
    // const imageZoomWrapper = document.querySelector('.image-zoom-wrapper');
    // const zoomedImage = imageZoomWrapper.querySelector('.zoomed-image');
    // const closeBtn = imageZoomWrapper.querySelector('.close-modal');
    //
    // const images = document.querySelector('.thumbnails-additional');
    // const navigateBtn = document.querySelectorAll('.images--wrap__arrow');
    //
    // const imagesItems = images.querySelectorAll('.cloud-zoom-gallery.sub-image');
    // const hrefArray = Array.from(imagesItems).map(image => image.href);
    //
    // if (imageWrap) {
    //     imageWrap.addEventListener('click', function () {
    //         const imgUrl = imageWrap.querySelector('#product-cloud-zoom');
    //         if (imgUrl) {
    //             const url = imgUrl.getAttribute('href');
    //             zoomedImage.setAttribute('src', url);
    //             imageZoomWrapper.classList.add('show-modal');
    //         }
    //     });
    // }
    //
    // if (navigateBtn) {
    //     navigateBtn.forEach((item) => {
    //         item.addEventListener('click', () => {
    //             const zoomedImageElement = document.querySelector('.zoomed-image');
    //
    //             if (!zoomedImageElement) {
    //                 console.log('No current image found.');
    //                 return;
    //             }
    //
    //             const currentImage = zoomedImageElement.getAttribute('src');
    //
    //             if (!currentImage) {
    //                 console.log('No current image source set.');
    //                 return;
    //             }
    //
    //             if (!hrefArray || !Array.isArray(hrefArray) || hrefArray.length === 0) {
    //                 console.log('Image array is invalid or empty.');
    //                 return;
    //             }
    //
    //             const currentIndex = hrefArray.findIndex(href => href.includes(currentImage));
    //
    //             if (currentIndex === -1) {
    //                 console.log('Current image is not found in the array.');
    //                 return;
    //             }
    //
    //             const isNext = item.className.includes('next');
    //             const isPrev = item.className.includes('prev');
    //
    //             if (!isNext && !isPrev) {
    //                 console.log('Invalid navigation action.');
    //                 return;
    //             }
    //
    //             let newIndex;
    //             if (isNext) {
    //                 newIndex = (currentIndex + 1) % hrefArray.length;
    //             } else if (isPrev) {
    //                 newIndex = (currentIndex - 1 + hrefArray.length) % hrefArray.length;
    //             }
    //             const nextImage = hrefArray[newIndex];
    //             zoomedImageElement.setAttribute('src', nextImage);
    //
    //             console.log(isNext ? 'NEXT' : 'PREV');
    //         });
    //     });
    // }


    const imageWrap = document.querySelector('.product-zoom-image');
    const imageZoomWrapper = document.querySelector('.image-zoom-wrapper');
    const zoomedImage = imageZoomWrapper.querySelector('.zoomed-image');
    const closeBtn = imageZoomWrapper.querySelector('.close-modal');

    if (imageWrap) {
        imageWrap.addEventListener('click', function () {
            const imgUrl = imageWrap.querySelector('#product-cloud-zoom');
            if (imgUrl) {
                const url = imgUrl.getAttribute('href');
                zoomedImage.setAttribute('src', url);
                imageZoomWrapper.classList.add('show-modal');
            }
        });
    }

    closeBtn.addEventListener('click', function () {
        imageZoomWrapper.classList.remove('show-modal');
    });

    imageZoomWrapper.addEventListener('click', function (e) {
        if (e.target === imageZoomWrapper) {
            imageZoomWrapper.classList.remove('show-modal');
        }
    });

    if(closeBtn){
        closeBtn.addEventListener('click', function () {
            imageZoomWrapper.classList.remove('show-modal');
        });
    }

    if(imageZoomWrapper){
        imageZoomWrapper.addEventListener('click', function (e) {
            if (e.target === imageZoomWrapper) {
                imageZoomWrapper.classList.remove('show-modal');
            }
        });
    }

    setTimeout(()=>{
        let paymentsButton = document.querySelector('.shopify-payment-button__more-options');
        if(paymentsButton) {
            paymentsButton.innerHTML = "Buy now";
        }
    }, 100)

});
